const $ = jQuery.noConflict();

'use strict';
const values = {

	$valueRow: $('.js-value-row'),

	init: function() {
		this.getHeights();
		this.setHeights();

		$(window).resize(function() {
			values.setHeights();
		});
	},

	getHeights: function() {
		this.$valueRow.each(function() {
			const title = $(this).find('.js-values-title');

			const maxHeight = Math.max.apply(null, title.map(function() {
				return $(this).height();
			}).get());

			// eslint-disable-next-line
			$(title).each(function(index, element) {
				$(this).addClass($(this).height() === maxHeight ? 'tallest' : 'short');
			});
		});
	},


	setHeights: function() {
		this.$valueRow.each(function() {
			const tallestTitle = $('.js-values-title.tallest');
			const shortTitle = $('.js-values-title.short');

			if ($(window).width() > 992) {
				shortTitle.css('height', tallestTitle.height());
			} else {
				shortTitle.css('height', 'auto');
			}
		});
	},
};

export default values;
